import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CardText = ({ type = "news" }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [items, setItems] = useState([]);
  const [animatePhase, setAnimatePhase] = useState("visible");
  const [visibleItem, setVisibleItem] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    async function load() {
      try {
        const res = await fetch(`/content/${type}/index.json`);
        const data = await res.json();
        const sliced = data.slice(0, 3);
        setItems(sliced);
        setVisibleItem(sliced[0]);
      } catch (err) {
        console.error("Error loading JSON content:", err);
      }
    }
    load();
  }, [type]);

  useEffect(() => {
    if (items.length <= 1) return;

    const emptyPauseDuration = 400;
    const visiblePauseDuration = 5000;

    let isCancelled = false;

    const runCycle = async () => {
      while (!isCancelled) {
        // Fade out
        setAnimatePhase("empty");
        await new Promise((res) => setTimeout(res, emptyPauseDuration));

        // Switch content while still hidden
        setVisibleItem((prev) => {
          const currentIndex = items.findIndex((item) => item === prev);
          const nextIndex = (currentIndex + 1) % items.length;
          return items[nextIndex];
        });

        // 💡 Give React a moment to commit the DOM update
        await new Promise((res) => setTimeout(res, 30));

        // Fade in
        setAnimatePhase("visible");
        await new Promise((res) => setTimeout(res, visiblePauseDuration));
      }
    };

    runCycle();

    return () => {
      isCancelled = true;
    };
  }, [items]);

  if (!visibleItem) return <p>Loading...</p>;

  if (isMobile) {
    return (
      <div className="mobile-card-text-wrapper" key={visibleItem.filename}>
        <div className="mobile-card-text-title">{visibleItem.title}</div>
        <div className="mobile-card-text-body">{visibleItem.intro}</div>
        <Link className="mobile-card-read-more" to={visibleItem.path}>
          Read More
        </Link>
      </div>
    );
  }

  return (
    <div className="card-text-container">
      <div
        className={`card-text-wrapper ${animatePhase}`}
        key={visibleItem.filename}
      >
        <div className="card-wrapper">
          <div className="card-text-title">{visibleItem.title}</div>
          <div className="card-text-body">{visibleItem.intro}</div>
          <Link className="card-read-more" to={visibleItem.path}>
            Read More
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CardText;
